import { render, staticRenderFns } from "./retain-dialog.vue?vue&type=template&id=4ae48460&scoped=true&lang=pug&"
import script from "./retain-dialog.vue?vue&type=script&lang=js&"
export * from "./retain-dialog.vue?vue&type=script&lang=js&"
import style0 from "./retain-dialog.vue?vue&type=style&index=0&id=4ae48460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae48460",
  null
  
)

export default component.exports